module.exports = __webpack_public_path__ + "media/images/extincteur-1d2085067d621168b294f0af246bfb2a.svg";